import { types } from 'mobx-state-tree';

export interface CategoryStatSingleItemProps {
  category: string;
  percent: number;
  total: number;
}

export const CategoryStatSingleItem = types.model({
  category: types.string,
  percent: types.number,
  total: types.number,
});
